export default {
  queries: {
    leftA: [],
    leftB: [],
    rightA: [],
    rightB: []
  },
  invokeSearch: [],
  query: {}
};